import styled from 'styled-components'

export const Wrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`

export const FormWrapper = styled.form`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const CardHeader = styled.div`
  /* border: 1px solid black; */
`

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const Row = styled.div`
  display: flex;
  align-items: end;
  flex-wrap: wrap;
  gap: 16px;
`

export const TrashContainer = styled.div`
  cursor: pointer;
`
